import { Component, OnInit } from '@angular/core';
import { User, Notify, RetailMessageService, SessionService, SharedService, PrintingService, PayTkt } from 'baseline-lib';
import { CustomToast } from '../../shared/services/custom-toast';
// import { PrintingService } from '../../_service/printing.service';
// import { SessionService } from '../../_service/session.service';
// import { SharedService } from '../../_service/shared.service';
// import { User } from '../../_models/common/user';
// import { Notify } from '../../_models/common/notify';
// import { PayTkt } from '../../_models/retailer/retail-report';
// import { RetailMessageService } from '../_services/retail-message.service';

@Component({
  selector: 'retail-pay',
  templateUrl: 'retail-pay.html'
})
export class RetailPayComponent {
  _ticket: {};
  _isPaid: any;
  authuser: User;
  _errorMsg: any;
  _execption: any;
  _tktDetails: any;
  _notify: Notify;

  payTSN: any;

  constructor(
    private _retailMessageService: RetailMessageService,
    private _sessionService: SessionService,
    public _sharedService: SharedService,
    private _printingService: PrintingService,
    private toast: CustomToast

  ) {
    this._notify = new Notify();
  }

  ngOnInit() {
  }

  printTkt() {
    this._printingService.printDetails("printingData");
  }

  validate() {
    this._tktDetails = '';
    if (!this.payTSN) {
      this._notify.errorMsg = "Ticket field can't be empty";
      this.toast.showError(this._notify.errorMsg);

      setTimeout(() => {
        this._notify.errorMsg = '';
      }, 3000);
      return false;
    }
    return true;
  }

  onPayBtnClick() {
    if (this.validate()) {
      this._sharedService.showLoader();
      this.authuser = this._sessionService.getAuthUser()
      if (this.authuser) {
        let payTktData = new PayTkt();
        payTktData.requestAccountId = 14;
        payTktData.tn = this.payTSN;
        payTktData.tokenId = this.authuser.tokenNo
        this._retailMessageService.getPayTkt(payTktData).subscribe(
          data => {
            this._sharedService.hideLoader();
            if (data) {
              this._tktDetails = data;
              this._sharedService.updateUserBalance(data.bal,data.ebal);
              this._isPaid = true;
              setTimeout(() => {
                this._isPaid = false;
              }, 2000);
            }
            this._ticket = {
              isPay: true,
              responseData: data,
            }
            this._sharedService.printingObj = this._ticket;
          },
          error => {
            this._sharedService.hideLoader();
            if (error.msg) {
              this._notify.errorMsg = error.msg;
            }
            else {
              this._notify.errorMsg = error.message;
            }
      this.toast.showError(this._notify.errorMsg);

            setTimeout(() => {
              this._notify.errorMsg = '';
            }, 2000);
          }
        )
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/retailer/retail-pay/retail-pay.ts